import React, { forwardRef } from 'react';

import { Declarant } from '@e-origin/shared';

import { UTBHeader } from './UTBHeader';
import { UTBReportBody, UTBReportBodyProps } from './UTBReportBody';

interface UTBReportTemplateProps extends UTBReportBodyProps {
  declarant: Declarant;
  logo?: string;
}

export const UTBReportTemplate = forwardRef<HTMLDivElement, UTBReportTemplateProps>(({ declarant, logo, t, ...bodyProps }, ref) => {
  return (
    <>
      {/* only visible on preview */}
      <UTBHeader declarant={declarant} logo={logo} t={t} />
      <UTBReportBody ref={ref} t={t} {...bodyProps} />
    </>
  );
});
